import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 首屏按浏览器语言设置标签页标题一次：中文用「智能客服」，其他用英文
const isZh = (navigator.language || navigator.userLanguage || '').toLowerCase().startsWith('zh')
document.title = isZh ? '智能客服' : 'Al Customer Service'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(router)
app.use(ElementPlus, {
    locale: zhCn,
})

app.mount('#app')
